export const ExportButtons = ({tasklist}) =>{
  const downloadCSV = ()=>{
    const rows = ["title,priority,deadline,category,completed,subtasks"];
    tasklist.forEach(t=>{
      const subs = (t.subtasks||[]).map(s=>s.text.replace(/,/g,'')).join("; ");
      rows.push(`"${t.name}",${t.priority||''},${t.deadline||''},${t.category||''},${t.completed? 'done':'pending'},"${subs}"`);
    });
    const csv = rows.join('\n');
    const blob = new Blob([csv], {type:'text/csv'});
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a'); a.href = url; a.download = 'tasks.csv'; a.click(); URL.revokeObjectURL(url);
  }

  const exportPDF = ()=>{
    const w = window.open('','_blank');
    const html = [`<html><head><title>Tasks</title><style>table{width:100%;border-collapse:collapse}td,th{border:1px solid #ccc;padding:6px}</style></head><body><h3>Tasks</h3><table><tr><th>Title</th><th>Priority</th><th>Deadline</th><th>Category</th><th>Status</th><th>Subtasks</th></tr>`];
    tasklist.forEach(t=>{
      const subs = (t.subtasks||[]).map(s=>s.text).join('; ');
      html.push(`<tr><td>${t.name}</td><td>${t.priority||''}</td><td>${t.deadline||''}</td><td>${t.category||''}</td><td>${t.completed? 'done':'pending'}</td><td>${subs}</td></tr>`)
    });
    html.push('</table></body></html>');
    w.document.write(html.join('\n'));
    w.document.close();
    w.print();
  }

  return (
    <div style={{display:'flex',gap:8}}>
      <button onClick={downloadCSV}>Export .csv</button>
      <button onClick={exportPDF}>Export .pdf</button>
    </div>
  )
}
